<template>
<div>
  <table id="slots" class="grid-view" style="--cols:0;" @mouseleave="returnNewSlots">
    <tr :key="i" v-for="(x,i) in this.slots">
      <td>
        <div v-if="x.available === true">
          <div @focusout="getNewSlotData(i)" ref="cells" contenteditable="true" class="cell-available-create">
            {{x['sample.code']}}
          </div>
        </div>
        <div v-else>
          <div ref="cells" class="cell-occupied-create"><em><b>{{x['sample.code']}}</b></em></div>
        </div>
      </td>
    </tr>
  </table>
</div>
</template>

<script>
import EventBus from "@/components/EventBus";
import {getStoredSampleDetails, returnUniquesInArray} from "@/utils/util_functions"

export default {
name: "SampleCreateBoxSlots",
  data(){
    return{
      slots:[], cols: null, rows: null,
      availableSlots: [], newSamples: [],
      time: 2000, // loader-time
    }
  },

  mounted(){
    EventBus.$on('slots-fetched', data => {
      this.slots = data

      let sample_storage_loc_details = getStoredSampleDetails()
      if (sample_storage_loc_details['slots'] !== null){
        // compare the 2 arrays and update the box-slots with the sampleCode that is in the savedForm
        for (let i = 0; i < sample_storage_loc_details['slots'].length; i++) {
          for (let x=0; x < this.slots.length; x++){
            if (this.slots[x].code === sample_storage_loc_details['slots'][i].slot_code) {
              this.slots[x]['sample.code'] = sample_storage_loc_details['slots'][i].sample
           }
          }
        }
      }
      // finally draw the slots
      this.drawSlots()
    })
  },

  methods: {
    resetBeforeChange(){
          this.rows = null;
          this.cols = null;
          this.availableSlots = []; this.newSamples = [];
          document.getElementById('slots').style.setProperty("--cols", "0");
    },

    drawSlots(){
      this.resetBeforeChange();

      // draw the slots of the selected box.
      // det the dimension of slots i.e rows and cols
      let last_slot = this.slots[this.slots.length - 1]
      this.rows = last_slot.position.row
      this.cols = last_slot.position.col

      // get slots that are available
      this.availableSlots = []
      for (let x=0; x < this.slots.length; x++){
        if (this.slots[x].available === true ){
          this.availableSlots.push(this.slots[x])
        }
      }

      let pad = document.getElementById('slots').style.getPropertyValue("--cols");
      document.getElementById('slots').style.setProperty("--cols", parseInt(pad) + this.cols);

      for (let i=0; i < this.slots.length; i++){
        if (this.slots[i].available === false){
          this.$refs.cells[i].style.backgroundColor = '#00b0ff'
        }
      }
    },

    getNewSlotData(index){
      let sample_code = this.$refs.cells[index].textContent.trim()

      /* Check that the sample-code does not exist and that the sample-code is not empty before returning new data
      * This ensure there are no duplicate sample codes. */
      const found = this.newSamples.some(el => el.sample === sample_code);

      /* Check that the current slot does not have an existing sample code,
      if it does, remove that from the newSamples array. This ensures that a slot does not hold more than i sample code*/
      let slotCode = this.slots[index].code

      for (let i=0; i < this.newSamples.length; i++){
        if (this.newSamples[i].slot_code === slotCode){
          //since slot has existing sample, update the sample code in slot
          this.newSamples[i].sample = sample_code
          return this.newSamples
        }
      }

      if (!found && sample_code !== '') this.newSamples.push({'slot_code': this.slots[index].code, 'sample':sample_code})
      return this.newSamples;
    },

    returnNewSlots(){
      let sample_storage_loc_details = getStoredSampleDetails()
      if (sample_storage_loc_details['slots'] !== null){
        // Set new samples
        this.newSamples = sample_storage_loc_details['slots']
      }
      // In-case in-slot validation failed at some point get unique data from new samples
      this.newSamples = returnUniquesInArray(this.newSamples)
      EventBus.$emit('new-samples', this.newSamples)
      // Emit event to save details about the selected sample location
      EventBus.$emit('sample_location_details', {'boxSlots': this.slots})
    }
  },
}
</script>